import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./ContentMobile.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IContentMobile } from "./IContentMobile";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import ContentMobileForm from "./ContentMobileForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listContentMobile } from "../../Redux/Slices/ContentMobile/ListContentMobileSlice";
import { clearAddContentMobileResponse } from "../../Redux/Slices/ContentMobile/AddContentMobileSlice";
import {
  clearDeleteContentMobileResponse,
  deleteContentMobile,
} from "../../Redux/Slices/ContentMobile/DeleteContentMobileSlice";
import { clearEditContentMobileResponse } from "../../Redux/Slices/ContentMobile/EditContentMobileSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listSubtopicMobile } from "../../Redux/Slices/SubtopicMobile/ListSubtopicMobileSlice";
import { listQuestionSubType } from "../../Redux/Slices/QuestionSubType/ListQuestionSubTypeSlice";

interface ContentMobileProps { }

const ContentMobile: FunctionComponent<ContentMobileProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IContentMobile | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listContentMobiles } = useAppSelector(
    (state) => state.ListContentMobileSlice
  );
  const { data: addContentMobile } = useAppSelector(
    (state) => state.AddContentMobileSlice
  );
  const { data: EditContentMobile } = useAppSelector(
    (state) => state.EditContentMobileSlice
  );
  const { data: deleteContentMobiles } = useAppSelector(
    (state) => state.DeleteContentMobile
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Content</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    // {
    //   field: "descriptioin",
    //   renderHeader: () => <b>Description</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IContentMobile>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const ContentMobile = Array.isArray(listContentMobiles?.data)
    ? listContentMobiles?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listContentMobile());
    // dispatch(listSideMenuPermission());
    // dispatch(listSubtopicMobile());
    dispatch(listQuestionSubType({}));
  }, [addContentMobile, EditContentMobile, deleteContentMobiles, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddContentMobileResponse());
      dispatch(clearEditContentMobileResponse());
      dispatch(clearDeleteContentMobileResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={ContentMobile ?? []} columns={columns}>
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listContentMobile())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Content`}
        Dialog_Content={
          <ContentMobileForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addContentMobile}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditContentMobile}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteContentMobile(deleteDialogData.id));
        }}
        response={deleteContentMobiles}
      />
    </>
  );
};

export default ContentMobile;
